import { NgModule } from '@angular/core';
import {
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbTagModule,
} from '@nebular/theme';

import { ThemeModule } from '@square-pos-integration/theme';
import { OrganizationDetailsRoutingModule } from './organization-details-routing.module';
import { OrganizationDetailsComponent } from './organization-details.component';

@NgModule({
  imports: [
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbTagModule,
    OrganizationDetailsRoutingModule,
  ],
  declarations: [
    OrganizationDetailsComponent,
  ],
})
export class OrganizationDetailsModule {}
